import { useNavigate, useLocation } from 'react-router-dom';

export const useSafeNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const navigateBack = (fallbackPath: string = '/') => {
    // Check if we came from another page in our app
    if (location.key && location.key !== 'default') {
      navigate(-1);
    } else {
      // If no previous location in our app, go to fallback
      navigate(fallbackPath);
    }
  };

  const navigateBackWithState = (fallbackPath: string = '/', state?: any) => {
    if (location.key && location.key !== 'default') {
      navigate(-1);
    } else {
      navigate(fallbackPath, { state });
    }
  };

  return {
    navigateBack,
    navigateBackWithState,
  };
};
